"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preloadFieldsOptions = preloadFieldsOptions;

var _effects = require("redux-saga/effects");

var _lodash = _interopRequireDefault(require("lodash"));

var apiFilterOptionsActions = _interopRequireWildcard(require("../../apiFlow/filterOptions/actions"));

var _component = require("../../../constants/component");

var _saga = require("../../apiFlow/filterOptions/saga");

var _actions2 = require("./actions");

var _selectors = require("../value/selectors");

var filterValueActions = _interopRequireWildcard(require("../value/actions"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(preloadFieldsOptions);

function preloadFieldsOptions(preloadFields, abortController) {
  var state, i, field, fieldName, filterType, options, optionsSource;
  return regeneratorRuntime.wrap(function preloadFieldsOptions$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)();

        case 2:
          state = _context2.sent;
          i = 0;

        case 4:
          if (!(i < preloadFields.length)) {
            _context2.next = 24;
            break;
          }

          field = preloadFields[i];
          fieldName = field[_component.PROPS.FIELD_NAME];
          filterType = field[_component.PROPS.FILTER_TYPE];
          options = field[_component.PROPS.DEFAULT_OPTIONS];
          optionsSource = field[_component.PROPS.OPTIONS_SOURCE]; // If field got default first option
          // load all filters options fields sequentially,
          // to pass the default value of each filter field as parameters for loading options of the next field

          if (!field[_component.PROPS.IS_DEFAULT_FIRST_OPTION]) {
            _context2.next = 14;
            break;
          }

          return _context2.delegateYield(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee() {
            var value, valueOptions, newValue;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!optionsSource) {
                      _context.next = 4;
                      break;
                    }

                    _context.next = 3;
                    return (0, _effects.call)(_saga.getFilterOptions, filterType, field[_component.PROPS.FIELD_NAME], optionsSource, abortController);

                  case 3:
                    options = _context.sent;

                  case 4:
                    _context.next = 6;
                    return (0, _effects.put)((0, _actions2.setOptions)(filterType, fieldName, options));

                  case 6:
                    value = (0, _selectors.getFieldValue)(state, filterType, fieldName) || "";
                    valueOptions = _lodash["default"].filter(options, function (opt) {
                      return opt.id.toString() === value.toString();
                    });

                    if (!(!field[_component.PROPS.IS_PRIMARY_FILTER] && !value || field[_component.PROPS.IS_PRIMARY_FILTER] && !value || valueOptions.length === 0)) {
                      _context.next = 13;
                      break;
                    }

                    newValue = null;

                    if (options && options.length > 0) {
                      newValue = [options[0].id];
                    } // Set first option value


                    _context.next = 13;
                    return (0, _effects.put)(filterValueActions.setField(filterType, fieldName, newValue));

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })(), "t0", 12);

        case 12:
          _context2.next = 21;
          break;

        case 14:
          if (!optionsSource) {
            _context2.next = 19;
            break;
          }

          _context2.next = 17;
          return (0, _effects.put)(apiFilterOptionsActions.saga(filterType, fieldName, optionsSource, abortController));

        case 17:
          _context2.next = 21;
          break;

        case 19:
          _context2.next = 21;
          return (0, _effects.put)((0, _actions2.setOptions)(filterType, fieldName, options));

        case 21:
          i++;
          _context2.next = 4;
          break;

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}